export default "__VITE_ASSET__B0dV$u9J__"